<template id="ForkIcon">
  <span v-b-tooltip.hover title="Number of Forks" class="fa fa-code-fork" />
</template>

<script>
export default {
  name: "ForkIcon",
};
</script>
